"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _admin = require("../../../../selectors/admin.js");
var _reactRedux = require("react-redux");
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Fortress = window.cccisd.fortress;
var roles = window.cccisd.appDefs.pawn.roles;
var nonManagedRoles = ['metricspawn', 'questprojectadmin', 'respondent', 'uberadmin'];
var RespondentConfig = /*#__PURE__*/function (_React$Component) {
  _inherits(RespondentConfig, _React$Component);
  var _super = _createSuper(RespondentConfig);
  function RespondentConfig() {
    _classCallCheck(this, RespondentConfig);
    return _super.apply(this, arguments);
  }
  _createClass(RespondentConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fields = _this$props.fields,
        waves = _this$props.waves,
        restrictionsLevel = _this$props.restrictionsLevel;
      var respondentConfig = fields.respondentConfig,
        respondentSelection = fields.respondentSelection;
      var isSuperUser = Fortress.isSuperUser();
      var isUber = Fortress.user.acting.role.handle === 'uberadmin';
      var respondentConfigOptions = [{
        value: 'anonymous',
        label: 'Anonymous: Respondents are not known until they take the Quest',
        show: true
      }, {
        value: 'manual',
        label: 'Known: I will add the respondents',
        show: true
      }, {
        value: 'previous',
        label: 'Copied: Start with respondents from another Data Collection Wave',
        show: waves.length > 0
      }].concat(_toConsumableArray(isSuperUser || isUber || restrictionsLevel === 'unlimited' ? [{
        value: 'managed',
        label: 'Managed: Allow respondents from my managed participants',
        show: roles && roles.length > 0
      }] : []));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-info"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-danger"
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
        spaceRight: true
      }), "You will not be able to change this later!"), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: respondentConfig,
        label: "How will you pick respondents for this Data Collection Wave?"
      }, respondentConfigOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "radio",
          key: option.value
        }, /*#__PURE__*/_react["default"].createElement("label", {
          style: !option.show ? {
            color: '#ccc'
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "radio"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(respondentConfig), {
          value: option.value,
          disabled: !option.show,
          checked: respondentConfig.value === option.value
        })), ' ', option.label));
      })), respondentConfig.value === 'previous' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: respondentSelection,
        label: "Select Wave:"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(respondentSelection), {
        style: {
          width: 'auto'
        }
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, "-- Choose a Wave --"), waves.filter(function (w) {
        return !w.parentDeploymentId;
      }).map(function (wave) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: wave.deploymentId,
          value: wave.deploymentId
        }, wave.label, " (", wave.assignment.label, ")");
      })))), respondentConfig.value === 'managed' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: respondentSelection,
        label: "Select Role:"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(respondentSelection), {
        style: {
          width: 'auto'
        }
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, "-- Choose a Role --"), roles.filter(function (role) {
        return !nonManagedRoles.includes(role.handle) || isSuperUser && role.handle === 'metricspawn';
      }).map(function (role) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: role.handle,
          value: role.handle
        }, role.label);
      })))));
    }
  }]);
  return RespondentConfig;
}(_react["default"].Component);
_defineProperty(RespondentConfig, "propTypes", {
  fields: _propTypes["default"].object,
  waves: _propTypes["default"].array,
  restrictionsLevel: _propTypes["default"].string
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    waves: (0, _admin.getCurrentProjectDeployments)(state.assignment.admin),
    restrictionsLevel: (0, _admin.getRestrictionsLevel)(state.assignment.admin)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(RespondentConfig);
exports["default"] = _default;